/**
 * Navigation Utilities
 * 导航工具函数
 */

let isNavigatingToLogin = false;

/**
 * 清除本地认证数据，防止登录态过期后因 localStorage 残留导致循环跳转
 */
const clearLocalAuthData = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("isAuthenticated");
  localStorage.removeItem("token");
  localStorage.removeItem("mockUser");
};

/**
 * 跳转到登录页
 * @param isHash 是否使用hash路由
 * @param backUrl 返回URL
 */
export const navigateToLogin = (isHash = false, backUrl?: string) => {
  // 如果已经在登录页，或者正在跳转中，则不再重复跳转，避免循环
  if (isNavigatingToLogin || window.location.pathname === "/login") {
    return;
  }
  isNavigatingToLogin = true;

  // 先清除本地认证数据，打破 "401 → 跳登录 → localStorage 仍为 true → 跳回首页" 的循环
  clearLocalAuthData();

  // 判断是否有重定向链接
  const params = new URLSearchParams(window.location.search);
  const redirect = params.get("redirectUrl");
  if (isHash) {
    window.location.hash =
      "#/login" + "?redirectUrl=" + (backUrl || window.location.pathname || "");
    return;
  } else {
    window.location.href =
      "/login" +
      "?redirectUrl=" +
      (backUrl
        ? backUrl
        : redirect
        ? decodeURIComponent(redirect)
        : window.location.pathname || "");
    return;
  }
};
